"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Event_1 = __importDefault(require("@mui/icons-material/Event"));
const FindInPage_1 = __importDefault(require("@mui/icons-material/FindInPage"));
const PersonAdd_1 = __importDefault(require("@mui/icons-material/PersonAdd"));
const LocalAtm_1 = __importDefault(require("@mui/icons-material/LocalAtm"));
const MonetizationOn_1 = __importDefault(require("@mui/icons-material/MonetizationOn"));
const CreditCard_1 = __importDefault(require("@mui/icons-material/CreditCard"));
const RequestQuote_1 = __importDefault(require("@mui/icons-material/RequestQuote"));
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const Paid_1 = __importDefault(require("@mui/icons-material/Paid"));
const PaidOutlined_1 = __importDefault(require("@mui/icons-material/PaidOutlined"));
const Payments_1 = __importDefault(require("@mui/icons-material/Payments"));
const PaymentsOutlined_1 = __importDefault(require("@mui/icons-material/PaymentsOutlined"));
const AccountBalance_1 = __importDefault(require("@mui/icons-material/AccountBalance"));
const AccountBalanceWalletOutlined_1 = __importDefault(require("@mui/icons-material/AccountBalanceWalletOutlined"));
const AttachMoney_1 = __importDefault(require("@mui/icons-material/AttachMoney"));
const CreditScore_1 = __importDefault(require("@mui/icons-material/CreditScore"));
const Phone_1 = __importDefault(require("@mui/icons-material/Phone"));
const AssignmentInd_1 = __importDefault(require("@mui/icons-material/AssignmentInd"));
const Comment_1 = __importDefault(require("@mui/icons-material/Comment"));
const GppGood_1 = __importDefault(require("@mui/icons-material/GppGood"));
const QuestionAnswer_1 = __importDefault(require("@mui/icons-material/QuestionAnswer"));
const Email_1 = __importDefault(require("@mui/icons-material/Email"));
const getIcon = (iconName) => {
    const options = {
        event: Event_1.default,
        find_in_page: FindInPage_1.default,
        person_add: PersonAdd_1.default,
        dollar_rect: LocalAtm_1.default,
        dollar_circ: MonetizationOn_1.default,
        credit_card: CreditCard_1.default,
        quotation: RequestQuote_1.default,
        info: Info_1.default,
        error: Error_1.default,
        paid: Paid_1.default,
        paid_outlined: PaidOutlined_1.default,
        payments: Payments_1.default,
        payments_outlined: PaymentsOutlined_1.default,
        account_balance: AccountBalance_1.default,
        wallet_outlined: AccountBalanceWalletOutlined_1.default,
        dollar_simple: AttachMoney_1.default,
        credit_score: CreditScore_1.default,
        phone: Phone_1.default,
        assignment_ind: AssignmentInd_1.default,
        code: GppGood_1.default,
        comment: Comment_1.default,
        question_answer: QuestionAnswer_1.default,
        email: Email_1.default,
    };
    return options[iconName] || Event_1.default;
};
const FontIcon = ({ iconName, sx }) => {
    const Icon = getIcon(iconName);
    return (0, jsx_runtime_1.jsx)(Icon, { sx: sx });
};
exports.FontIcon = FontIcon;
